<mat-form-field class="full-width" appearance="outline" [attr.aria-busy]="adminLoading()">
  <mat-label>{{ getLabel() }}</mat-label>

  <input matInput [formControl]="displayControl" [attr.aria-label]="getLabel()" [readonly]="true" />
  @if (!readonly()) {
    <button
      color="primary"
      matIconSuffix
      mat-icon-button
      (click)="onAdminSelect()"
      [attr.aria-label]="'Select Administrator' | translate: locale.language"
      type="button">
      <mat-icon aria-hidden="true">person_search</mat-icon>
    </button>
  }
  <mat-hint>{{ hint() }}</mat-hint>
  @if (adminLoading()) {
    <span class="cdk-visually-hidden">
      {{ 'Loading' | translate: locale.language }}
    </span>
  }
</mat-form-field>
